<template>
  <div class="accordion mt-2 mb-5" id="accordionExample">
    <div v-for="(section, index) in sections" :key="index" class="card">
      <div class="card-header" :id="'heading' + index">
        <h2 class="mb-0">
          <button
            class="btn btn-link btn-block text-left"
            type="button"
            data-toggle="collapse"
            :data-target="'#collapse' + index"
            aria-expanded="true"
            :aria-controls="'collapse' + index"
            style="display: flex; justify-content: space-between;"
          >
            <span><p style="font-weight:bold" class="m-0">{{ section.titulo }}</p></span>
            <span class="descargar"><i class="bx bx-chevron-down icono-down"></i></span>
          </button>
        </h2>
        <div
          :id="'collapse' + index"
          class="collapse"
          :aria-labelledby="'heading' + index"
          data-parent="#accordionExample"
        >
          <div class="card-body">
            <ul>
              <li v-for="(contenido, i) in section.contenido" :key="i"> <!-- Cambiado 'section.contenidos' a 'section.contenido' -->
                <a :href="urlServe + contenido.url_pdf" target="_blank">{{ contenido.titulo }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    sections: {
      type: Array,
      required: true
    },
    urlServe: {
      type: String,
      default: ''
    }
  }
};
</script>

<style scoped>
.accordion .card .card-header {
    border-radius: 0!important;
    margin-bottom: -1px!important;
    background-color: #fff!important;
}
.card-header:first-child {
    border-radius: calc(.25rem - 1px) calc(.25rem - 1px) 0 0!important;
}
.card-header {
    padding: .75rem 1.25rem!important;
    margin-bottom: 0!important;
    background-color: rgba(0, 0, 0, .03)!important;
    border-bottom: 1px solid rgba(0, 0, 0, .125)!important;
}
.card-header span{
    color:#621132;
    transition: ease all .1s;
    font-weight: 400;
}
.card-header span:hover{
    transform: scale(1.04);
    border: none !important;;
}
.card-body li{
    list-style-type: none;
    list-style: none;
    margin-bottom: 1rem;
    border-bottom: 1px dotted rgb(189, 182, 182);
    padding: .2rem;
    padding-left: 0 !important;
    font-size: 14px;
    transition: ease all .1s;
}
.card-body li:hover{
     transform: scale(1.01);
}
.card-body ul li a{
    color: #000!important;
    text-decoration: none;
    cursor: pointer;
}
</style>
